import axios from '../request/http'
const serviceArticle = {

    // 管理台端文章置顶
    topArticle(data) {
        return axios.post("/service-article/article/top", data);
    },
    //  取消管理台端文章置顶
    cancelArticle(data) {
        return axios.post("/service-article/article/cancel/top", data);
    }
}

export default serviceArticle;



// WEBPACK FOOTER //
// ./src/api/serviceArticle.js